import React from 'react';
import Navbar from '../layouts/navbar';
import {Link} from 'react-router-dom';

const storyEduForum=(props)=>{
    return(
        <div>
            <Navbar head="Explore" />
        <div className="container" style={{fontFamily:"'Open Sans',sans-serif",marginTop:"50px"}}>
            <div className="row mt-4 d-none d-md-block ">
                <div className="col-12">
                    <h1 className="text-left" >We don't just carve paths, we walk you.<br></br>
                        Helped a few, will help you too!
                    </h1>
                    <p style={{fontSize:"1.2rem"}}>We call connection: an antidode to addiction! Let's build a few: here are a few, like me and you, let their stories be the first chapter to yours, let their reasons be one of yours.</p>
                </div>
                
            </div>
            <div className="row justify-content-center mt-5">
                <div className="col-12 col-lg-4">
                    <Link to="/stories">
                    <div className="card">
                        <img className="card-img" src="/assests/images/stories.png" alt="">
                        </img>
                        <div className="card-img-overlay d-flex align-items-center
                        justify-content-center">
                            <h3 className="card-title text-white">Stories</h3>
                        </div>
                    </div>
                    </Link>
                </div>
                <div className="col-12 col-lg-4">
                    <Link to="/educationexplore">
                    <div className="card ">
                        <img className="card-img" src="/assests/images/education.png" alt="">
                        </img>
                        <div className="card-img-overlay d-flex align-items-center
                        justify-content-center">
                            <h3 className="card-title text-white">Education</h3>
                        </div>
                    </div>
                    </Link>
                </div>
                <div className="col-12 col-lg-4">
                    <Link to="/forum">
                    <div className="card ">
                        <img className="card-img " src="/assests/images/forum.png" alt="">
                        </img>
                        <div className="card-img-overlay d-flex align-items-center justify-content-center">
                            <h3 className="card-title text-white">Forum</h3>
                        </div>
                    </div>
                    </Link>
                </div>
            </div>
        </div>
        </div>
    )
}

export default storyEduForum;